export { useWaitingTrackingInfoCopy } from './useWaitingTrackingInfoCopy.hook';
